import { useState } from 'react';
import { bandejaSilenciada, silenciarBandeja } from '../../lib/inbox-sound.ts';

/**
 * Silencia el aviso de conversación nueva.
 *
 * La preferencia se recuerda entre sesiones: un operador que trabaja con la
 * bandeja abierta todo el día no debería tener que apagar el sonido cada vez que
 * entra. Vive acá, junto al indicador "En vivo", porque los dos hablan de lo
 * mismo: cómo se entera de lo que llega.
 */
export function BotonSilencio() {
  const [silenciada, setSilenciada] = useState(bandejaSilenciada);

  const alternar = () => {
    const proxima = !silenciada;
    silenciarBandeja(proxima);
    setSilenciada(proxima);
  };

  const etiqueta = silenciada
    ? 'Activar sonido de conversación nueva'
    : 'Silenciar sonido de conversación nueva';

  return (
    <button
      type="button"
      onClick={alternar}
      title={etiqueta}
      aria-label={etiqueta}
      aria-pressed={silenciada}
      className="p-1.5 rounded text-neutral-500 hover:text-neutral-800 dark:text-neutral-400 dark:hover:text-neutral-100 hover:bg-neutral-100 dark:hover:bg-neutral-800 transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary-500"
    >
      <svg viewBox="0 0 24 24" className="w-4 h-4" fill="none" stroke="currentColor" role="img">
        <title>{etiqueta}</title>
        <path
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9M13.7 21a2 2 0 0 1-3.4 0"
        />
        {silenciada && <path strokeWidth="2" strokeLinecap="round" d="M3 3l18 18" />}
      </svg>
    </button>
  );
}
